import React from "react";
// InlineOrModal: a plain ReactModal, except inside the quote workspace (no pop-ups) where it opens in place.
import InlineOrModal from "../../core/components/InlineOrModal";
import { useInlineSurface } from "../../core/components/InlineOrModal/inlineSurface";

import { MobileTopbar } from "../../components/layout";
import ContactWizard from "./Wizard.jsx";
import { contactWizardModalStyles } from "../../core/utils/responsiveModalStyles.js";

const SupplierWizardModal = ({
  isOpen,
  onClose,
  afterSubmit,
  title = "New Supplier",
  submitLabel = "Create supplier",
  // Pre-selects the contact's user type. Overridable (NEW WATCHMAKER passes
  // "watchmaker") and still changeable by the rep inside the wizard — the
  // dropdown is a normal field, this only decides where it starts.
  defaultType = "supplier",
}) => {
  // Inside the quote workspace the wizard opens in place: no app topbar of its
  // own (the page already has one) and no extra close — it has ← Back.
  const inline = useInlineSurface();

  return (
  <InlineOrModal
    inlineClose={false}
    isOpen={isOpen}
    onRequestClose={onClose}
    style={contactWizardModalStyles}
    className="rc-supplier-wizard-modal"
    overlayClassName="rc-supplier-wizard-modal-overlay"
    contentLabel={title}
  >
    <div className="users-dark users-dark--modal users-dark--create rc-supplier-wizard-modal__shell">
      {!inline && <MobileTopbar />}
      <div className="users-create-wrap users-create-wrap--modal">
        <div className="users-create-wrap__header">
          <button type="button" className="users-create-wrap__back" onClick={onClose}>
            ← Back
          </button>
          <h2 className="users-create-wrap__title">{title}</h2>
        </div>
        <ContactWizard
          className="users-create-form"
          afterSubmit={afterSubmit}
          onCancel={onClose}
          submitLabel={submitLabel}
          defaultType={defaultType}
        />
      </div>
    </div>
  </InlineOrModal>
  );
};

export default SupplierWizardModal;
